// extracted by mini-css-extract-plugin
export default {"Lobby":"Lobby_Lobby__FxJP6","ButtonWrapper":"Lobby_ButtonWrapper__A3eWi"};